<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='提交订单'">
    <div class="info border-box">
      <div class="item box">
        <div class="l">讲解服务</div>
        <div class="flex r hide">{{productInfo.name}}  <font v-if="productInfo.type==2"> ({{productInfo.people}}人团)</font></div>
      </div>
      <div class="item box" v-if="productInfo.type==1 && productInfo.guidetype && JSON.parse(productInfo.guidetype).length>0">
        <div class="l">讲解语音</div>
        <div class="flex r hide">{{getNameByCode(productInfo.guidetype,guideCode)}}</div>
      </div>
      <div class="item box" v-if="productInfo.type==1 && productInfo.peopletype && JSON.parse(productInfo.peopletype).length>0">
        <div class="l">使用人数</div>
        <div class="flex r hide">{{getNameByCode(productInfo.peopletype,peopleCode)}}</div>
      </div>
      <div class="item box">
        <div class="l">预约时间</div>
        <div class="flex r">{{productInfo.date}} {{productInfo.stime}}-{{productInfo.etime}}</div>
      </div>
      <div class="item box" v-if="productInfo.type==2">
        <div class="l">单价</div>
        <div class="flex r cor-p" >￥{{productInfo.sellprce}}</div>
      </div>
      <div class="item" v-if="productInfo.type==2">
        <div class="box">
          <div class="l">购买数量</div>
          <div class="flex r number">
            <i class="fr calc jia" :class="((ordernum1==''&&pNumber>=productInfo.people)||(ordernum1&&(pNumber>=(productInfo.people-productInfo.tuanPeople))))?'disabled':''" @click="addFun(2)"></i>
            <!--<input class="fr" type="number" v-model="pNumber" readonly>-->
            <input class="fr" type="tel" v-model.number="pNumber" v-on:input="inputNum(pNumber,2)" >
            <i class="fr calc jian" :class="pNumber==1?'disabled':''" @click="minFun(2)"></i>
          </div>
        </div>
        <div class="tip-box border-box box" style="padding: 0 .24rem;">
          <img class="icon-tip" src="../../assets/tip02.png" alt="" style="margin-top: 0.21rem;">
          <span class="flex mid">{{productInfo.people}}人拼团，未拼成功费用将原路返回！</span>
          <span class="right"@click="OrderknowShow()">预约须知<img class="fr" src="../../assets/right01.png" alt=""></span>
        </div>
      </div>
    </div>

    <div class="info border-box">
      <div class="tit">游客信息</div>
      <div class="item box">
        <div class="l">联系人</div>
        <div class="flex r">
          <input type="text" placeholder="必填，输入联系人姓名" v-model="userName">
        </div>
      </div>
      <div class="item box" v-if="scenicId!=1">
        <div class="l">身份证号</div>
        <div class="flex r">
          <input type="tel" placeholder="必填，身份证号" v-model="card">
        </div>
      </div>
      <div class="item box">
        <div class="l">手机号码</div>
        <div class="flex r">
          <input type="tel" placeholder="必填，手机号码" v-model="phone">
        </div>
      </div>
      <div class="item box">
        <div class="l">验证码</div>
        <div class="flex r">
          <input type="tel" maxlength="6" placeholder="必填，验证码" v-model="code">
        </div>
        <button class="btn" @click="getYzm">{{buttonText}}</button>
      </div>
      <div class="item" v-if="productInfo.type==1">
        <div class="box">
          <div class="l">出行人数</div>
          <div class="flex r number">
            <i class="fr calc jia" :class="pNumber==productInfo.people?'disabled':''" @click="addFun"></i>
            <input class="fr" type="tel" v-model.number="pNumber" v-on:input="inputNum(pNumber)" >
            <i class="fr calc jian" :class="pNumber==1?'disabled':''" @click="minFun"></i>
          </div>
        </div>
        <div class="box ej-box" v-if="productInfo.etype==1">
          <div class="l">是否需要耳机</div>
          <div class="flex r">
            <span class="icon-che1" :class="eneed==1?'':'curr'" @click="erClick(0)">不需要</span>
            <span class="icon-che2" :class="eneed==1?'curr':''" @click="erClick(1)">需要</span>
          </div>
        </div>
        <div class="tip-box border-box box">
          <img class="icon-tip" src="../../assets/tip02.png" alt="">
          <div class="flex mid" v-if="productInfo.etype==1">
            <font v-if="productInfo.eprice>0">耳机：{{productInfo.eprice}}元/人； </font>  如果需要耳机，我们会按照实际预约(购买)人数发放
            <span @click="OrderknowShow()">预约须知<img src="../../assets/right01.png" alt=""></span>
          </div>
          <div class="flex mid" v-if="productInfo.etype!=1">准确的出行人数，便于我们为您准备讲解设备，讲解设备按照实际预约(购买)人数发放！ <span @click="OrderknowShow()">预约须知<img src="../../assets/right01.png" alt=""></span></div>
        </div>
      </div>
    </div>

    <div class="info border-box" v-if="pneed==1">
      <div class="tit" @click="piaoClick">申请开票
        <img class="tit-check"  :src="pneed==1?require('../../assets/check-curr.png'):require('../../assets/check.png')" alt="">
      </div>
      <div v-if="pneed==1">
        <div class="item box">
          <div class="l">发票抬头</div>
          <div class="flex r">
            <input type="text" placeholder="请输入发票抬头" v-model="piaotitle">
          </div>
        </div>
        <div class="item box">
          <div class="l">税号</div>
          <div class="flex r">
            <input type="text" placeholder="企业开票税号必填" v-model="piaonum">
          </div>
        </div>
        <div class="item box">
          <div class="l">接收邮箱</div>
          <div class="flex r">
            <input type="tel" placeholder="电子发票接收邮箱" v-model="email">
          </div>
        </div>
      </div>
    </div>


    <div class="bot-box bgF box border-box">
      <div class="flex">总价:
        <span class="cor-p">￥<font>{{productInfo.allprice}}</font></span>
        <!--<font v-if="productInfo.vprice>0" style="margin-left:.15rem;color:#999;font-size:.24rem;font-weight:normal;">￥{{productInfo.temprice}}+￥{{productInfo.vprice}}服务费</font>-->
      </div>
      <div class="bot-detail" :class="detailShow==1?'curr':''" @click="detailShowFun">
        <span class="fl">明细</span>
        <img class="fl" src="../../assets/icon-down1.png" alt="">
      </div>
      <div class="btn linear" @click="payOrder()">提交订单</div>
    </div>

    <div class="bot-detail-alert" v-if="detailShow==1">
      <div class="mask" @click="detailShow=0"></div>
      <div class="bot-detail-con border-box">
        <div class="detail-item">出行人数<span class="fr">{{pNumber}}人</span></div>
        <div class="detail-item"  v-if="productInfo.type==2">拼团票<span class="fr">￥{{productInfo.sellprce}} x {{pnum}}人</span></div>
        <div class="detail-item" v-if="eneed==1&&productInfo.eprice>0">耳机费用<span class="fr">￥{{productInfo.eprice}} x {{pNumber}}人</span></div>
        <div class="detail-item" v-if="eneed==1&&productInfo.erji>0">耳机总价<span class="fr">￥{{productInfo.erji}}</span></div>
        <div class="detail-item cor-p">订单总价<span class="fr">￥{{productInfo.temprice}}(讲解费) <font v-if="productInfo.vprice>0">+ ￥{{productInfo.vprice}}(预约服务费)</font></span></div>
      </div>
    </div>
    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

    <img class="to-home" src="../../assets/to-home.png" @click="toHome" alt="">

    <!--预约须知-->
    <AlertOrderKnow :type="'desc'" :curritem="curritem"  v-if="curritem && curritem.info" v-on:child-orderKnow="closeOrderKnow"></AlertOrderKnow>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import AlertOrderKnow from '../../components/AlertOrderKnow'
  import {getPayPreOrder, getPayPreCanOrder, getPhoneCode, getPiao2 } from "@/service/getData";
  import {creatOrder,wxGetPosition,wxShareme,wxOpenMapLocation} from '@/utils/wechat'
  import {setStore, getStore, removeStore,regIdCard} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  import '@/utils/base64'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        P400: 0, //系统维护中
        scenicId: this.$route.query.scenicId || 1, //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记

        ptype: this.$route.query.ptype || 1, //1:包团 2拼团
        ordernum1 : this.$route.query.ordernum1 || '', //参与的拼团的团单号
        guideCode: this.$route.query.guideCode || '', //选的讲解类型编码
        timeId:  this.$route.query.timeId || '', //选的 讲解时段id
        peopleCode:  this.$route.query.peopleCode || '', //选的人数类型编码
        siteId:  this.$route.query.siteId || '', //选的线路id
        eneed: 0, //是否需要耳机 1需要
        pnum: 1, //购买数量，团购>=1，包团==1
        productInfo:'',//预定的产品信息

        orderKnow:0,//预订须知0：隐藏 1：显示

        hasChild:0,//是否携带儿童 0：否 1：是
        pNumber:1,//游客人数
        userName:'',//出游人姓名
        card:'',//出行人身份证
        cardNow:'',
        phone:'',//出游人电话
        phoneNow:'',
        touristList:[{userName:'',userId:'',userPhone:'',isChild:false}],//游客信息列表
        touristInfo:'',//游客列表信息

        buttonText:'发送验证码',
        code:'',//验证码
        needYzm:1,//是否需要验证码
        detailShow:0,//明细弹窗是否显示

        curritem:0,//预订须知0：隐藏 有信息显示

        ordernum: '',//创建的订单编号
        pneed: 0, //是否需要发票
        piaotitle: '',//发票抬头
        piaonum: '',//税号
        email: '',//接收邮箱

      }
    },
    computed: {},
    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
//      this.pneed = (this.ptype==1?1:0);
      if(this.ordernum1){
        this.getPayPreCanOrderFun();
      }else {
        this.getPayPreOrderFun();
      }
//      this.getPiaoFun()
    },
    methods: {

      //获取订单预生成信息(预约/发起拼团)
      async getPayPreOrderFun(){
        let res = await getPayPreOrder({
          openid: this.userInfo.openid,
          num: this.pnum,
          guideCode: this.guideCode,
          peopleCode: this.peopleCode,
          siteId: this.siteId,
          timeId: this.timeId,
          people: this.pNumber,
          eneed: this.eneed,
          pneed: this.pneed
        });
        this.$loading.hide();
        if (res.errcode == "00000") {
          this.productInfo = res.data;

          var data = res.data;
          this.userName = this.userName?this.userName:(data.username || '');
          this.phone = this.phone?this.phone:(data.phone || '');
          this.card =  this.card?this.card:(data.idcard || '');

          //etype 1 表示可以勾选是否需要耳机配置  eprice 单人耳机附加费用
          //erji  勾选耳机之后  耳机附加费用  temprice 选择总价(不含平台服务费)  allprice选择总价（包含平台服务费）
          //vprice 平台服务费
        }else {
          this.$toast(res.errmsg);

          var self = this;
          setTimeout(function(){
            self.$router.back()
          },1500);
        }
      },

      //获取去参团预生成信息(去参团)
      async getPayPreCanOrderFun(){
        let res = await getPayPreCanOrder({
          openid: this.userInfo.openid,
          num: this.pnum,
          ordernum: this.ordernum1,
          pneed: this.pneed
        });
        this.$loading.hide();
        if (res.errcode == "00000") {
          this.productInfo = res.data
          this.userName = this.productInfo.username || '';
          this.phone = this.productInfo.phone || '';
          this.card = this.productInfo.idcard || '';
        }else {
          this.$toast(res.errmsg);

          var self = this;
          setTimeout(function(){
            self.$router.back()
          },1500);
        }
      },
      //根据code值获取name
      getNameByCode: function (str,code){
        var arr = JSON.parse(str), res = '';
        for(var i=0; i<arr.length; i++){
          if(arr[i].code == code){
            res = arr[i].name;
            break;
          }
        }
        return res;
      },

      //获取历史开票信息
      async getPiaoFun(){
        let res = await getPiao2({
          openid: this.userInfo.openid,
        })
        if (res.errcode == "00000") {
          this.piaotitle = res.data.title || '';
          this.piaonum = res.data.num || '';
          this.email = res.data.email || '';
        }
      },

      //发送验证码
      async getYzm(){
        if(this.buttonText != '发送验证码'){
          return
        }
        if (this.phone == undefined || this.phone == '' || this.phone == null || !(/^1[0-9]{10}$/.test(this.phone))) {
          this.$toast('请正确填写用于接收确认短信的联系电话');
          return
        }
        let res = await getPhoneCode({
          phone:this.phone,
          type: 1,
          scenicId: this.scenicId
        });
        var self = this;
        if(res.errcode == "00000"){
          this.$toast("发送成功！");
          this.buttonText = "重新发送60";
          //倒计时1分钟
          var count = 59;
          var countdown = setInterval(CountDown, 1000);
          function CountDown() {
            self.buttonText = "重新发送" + count;
            if (count == 0) {
              clearInterval(countdown);
              self.buttonText = "发送验证码";
            }
            count--;
          }
        }else{
          this.$toast(res.errmsg);
          this.buttonText = "发送验证码";
        }

      },

      //选择是否开票
      piaoClick: function (){
        this.pneed = (this.pneed==1?0:1);
        if(this.ordernum1){
          this.getPayPreCanOrderFun();
        }else {
          this.getPayPreOrderFun();
        }
      },
      //预约须知弹窗隐藏
      closeOrderKnow :function(msg){
        this.orderKnow = 0;
      },

      //人数输入框
      inputNum(val,type){
        if((this.ordernum1=='' && val > this.productInfo.people) || (this.ordernum1 && (val>(this.productInfo.people-this.productInfo.tuanPeople)))){
          this.pNumber = 1;
          this.$toast('超过限制游玩人数了~');
        }else {
          this.pNumber = val;
          if(val==''||val==undefined){
            this.pNumber = 1
          }
          if(type==2) { //拼团购买数量
            this.pnum = this.pNumber;
          }
          if(this.eneed==1 || type==2){ //需要耳机 或是 拼团状态
            if(this.ordernum1){
              this.getPayPreCanOrderFun();
            }else {
              this.getPayPreOrderFun();
            }
          }
        }
      },
      //游客人数加
      addFun:function(type){
        if((this.ordernum1=='' && this.pNumber >= this.productInfo.people) || (this.ordernum1 && (this.pNumber>=(this.productInfo.people-this.productInfo.tuanPeople)))){
          this.$toast('不能再增加游玩人数了~');
        }else{
          this.pNumber = parseInt(this.pNumber) + 1;
          this.touristList.push({userName:'',userId:'',userPhone:'',isChild:false,message:''});

          if(type==2) { //拼团购买数量
            this.pnum = this.pNumber;
          }

          if(this.eneed==1 || type==2){ //需要耳机 或是 拼团状态
            if(this.ordernum1){
              this.getPayPreCanOrderFun();
            }else {
              this.getPayPreOrderFun();
            }
          }
        }
      },
      //游客人数减
      minFun:function(type){
        if(this.pNumber == 1){
          this.$toast('游玩人数不能再少了~');
        }else{
          this.pNumber = this.pNumber - 1;
          this.touristList.splice(this.touristList.length-1,1);

          if(type==2) { //拼团购买数量
            this.pnum = this.pNumber;
          }

          if(this.eneed==1 || type==2){ //需要耳机 或是 拼团状态
            if(this.ordernum1){
              this.getPayPreCanOrderFun();
            }else {
              this.getPayPreOrderFun();
            }
          }
        }
      },

      //选择是否需要耳机
      erClick: function (val){
        this.eneed = val;
        if(this.ordernum1){
          this.getPayPreCanOrderFun();
        }else {
          this.getPayPreOrderFun();
        }
      },

      //删除某一条游客信息
      delFun: function(i){
        this.touristList.splice(i,1);
        this.pNumber = this.pNumber - 1;
      },

      //选择是否包含儿童
      hasChildFun:function (i){
        if(this.touristList[i].isChild==false){
          this.touristList[i].isChild = true;
        }else{
          this.touristList[i].isChild = false;
        }
      },

      //点击提交订单
      payOrder: function (){
        if (this.userName == undefined || this.userName == '' || this.userName == null) {
          this.$toast('请正确填写联系人姓名');
          return
        }
        if (this.phone == undefined || this.phone == '' || this.phone == null || !(/^1[0-9]{10}$/.test(this.phone))) {
          this.$toast('请正确填写用于接收确认短信的联系电话');
          return
        }
        if(this.scenicId!=1 && !regIdCard(this.card)){ //非川博，身份证必传
          this.$toast('请正确填写身份证号');
          return
        }
        if(this.code==''){
          this.$toast('请填写验证码');
          return
        }

        if(this.pneed==1 && !this.piaotitle){
          this.$toast('请填写发票抬头');
          return
        }
        if(this.pneed==1 && !this.email){
          this.$toast('请填写电子发票接收邮箱');
          return
        }

        var self = this;
        this.$confirm({
          title: '提示',
          content: '确定是选择'+this.pNumber+'人出行吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.submitOrder()
          }
        }).catch(function(res){
          if(res == 'success') {
            self.submitOrder()
          }
        });


      },
      //最终提交
      submitOrder: function (){
        var obj = {
          openid: this.userInfo.openid,
          num: this.pnum || 1,
          timeId: this.timeId,
          people:this.pNumber,
          username: this.userName,
          phone: this.phone,
          idcard: this.card || '',
          code: this.code || '0000',
          eneed: this.eneed,
          pneed: this.pneed,
          piaotitle: this.piaotitle || '',
          piaonum: this.piaonum || '',
          email: this.email || ''
        };  //拼团

        if(this.productInfo && this.productInfo.type==1){ //包团
          obj.guideCode = this.guideCode;
          obj.peopleCode = this.peopleCode;
          obj.siteId = this.siteId;
        }else if(this.productInfo && this.productInfo.type==2 && this.ordernum1){ //参团
          obj.ordernum = this.ordernum1;
        }

        //提交订单，发起支付
        var self = this;
        creatOrder(this,obj,function(data){
          if(data){
            self.$router.replace({
              path: `/order-desc?${'ordernum='+self.ordernum+'&scenicId='+self.scenicId+'&scenicKey='+self.scenicKey}`
            });
          }
        })
      },

      //去往集合地点
      openMap: function (){
        wxOpenMapLocation(this.productInfo.lat, this.productInfo.lng, this.productInfo.shopname, this.productInfo.address)
      },

      //明细弹窗显示
      detailShowFun:function(){
        if(this.detailShow==1){
          this.detailShow = 0;
        }else{
          this.detailShow = 1;
        }
      },

      //预约须知弹窗隐藏
      closeOrderKnow :function(msg){
        this.curritem = 0;
      },

      //跳转至提交预约信息页面
      OrderknowShow: function (){
        this.curritem = this.productInfo
      },

      //返回至首页
      toHome(){
        this.$router.replace({path: `/?scenicId=`+this.scenicId+'&scenicKey='+this.scenicKey });
      },
    },
    watch: {},
    components: {P400,AlertOrderKnow},
  }

</script>

<style scoped>
  .page{min-height:100vh;padding: .2rem .3rem 1.3rem;background-color:#f2f2f2}
  .info{position:relative;margin-top:.2rem;padding: .1rem .3rem;background: #fff;border-radius: .13rem;}
  .info:first-child{margin-top: 0;}
  .info .del-btn{position: absolute;top:.3rem;right: .2rem;height: .36rem;font: .24rem/.36rem "Microsoft YaHei";color: #666;}
  .info .del-btn img{width: auto;height: .36rem;margin-left: .1rem;}
  .item{padding: .18rem 0;line-height: .54rem;border-bottom:1px solid #e3e3e3;}
  .item:last-child{border-bottom: none;}
  .info .tit{font: .32rem/1rem "Microsoft YaHei";color: #666;}
  .info:first-child .item .l{color:#666;}
  .info .tit-check{float: right; margin-top: .25rem; width: .5rem;height: .5rem;}

  .item .l{width: 1.5rem;font: .32rem/.54rem "Microsoft YaHei";color: #333;}
  .item .r{font: .28rem/.54rem "Microsoft YaHei";color: #222;text-align: right;}
  .item .r.number .calc {display: inline-block;width: .54rem;height: .54rem; }
  .item .r.number .jia {background: url(../../assets/jia-curr.png) no-repeat center;background-size: 100% 100%;}
  .item .r.number .jia.disabled {background: url(../../assets/jia.png) no-repeat center;background-size: 100% 100%;}
  .item .r.number .jian {background: url(../../assets/jian-curr.png) no-repeat center;background-size: 100% 100%;}
  .item .r.number .jian.disabled {background: url(../../assets/jian.png) no-repeat center;background-size: 100% 100%;}
  .item .r.number input {width: .8rem;height: .54rem;line-height: .54rem;text-align: center;font-size: .32rem;color: #333;}
  .item.check .l span{margin-left: .06rem;}
  .item.check .r{width: .46rem;}
  .item.check .r img{float:right;width: .46rem;height: .46rem;margin-top: .04rem;}
  .item .btn{font-size: .28rem; color: #0787f2; margin-left: .1rem; background: none;}

  .tip-box{width: 100%;margin-top:.24rem;padding: .2rem .18rem;border-radius: .06rem;background: #fcf0e3;color: #e58619;}
  .icon-tip{width: auto;height: .22rem;margin-top: 0.04rem;margin-right: 0.08rem;vertical-align: top;}
  .tip-box .mid{font: .22rem/.32rem "Microsoft YaHei";}
  .tip-box .mid span{display:inline-block;font: .22rem/.32rem "Microsoft YaHei";vertical-align: top;text-decoration: underline;margin-left: .2rem}
  .tip-box .mid span img{width: auto;height: .16rem;margin-top: .06rem;margin-left: .06rem;vertical-align: top;}
  .tip-box .right{display: inline-block;width: 1.15rem;margin-left:.2rem;font: .22rem/.64rem "Microsoft YaHei";}
  .tip-box .right img{width: auto;height: .16rem;margin-top: .24rem;margin-left: .06rem;vertical-align: top;}
  .item input{display:inline-block;width:100%;text-align: right;font-size: .28rem;}
  .bot-box{position: fixed;left: 0;bottom: 0;width: 100vw;height: .98rem;padding:0 .3rem;border-top:1px solid #e3e3e3;}
  .bot-box .flex{font:bold .24rem/.98rem "Microsoft YaHei";color: #333;}
  .bot-box .flex font{font-size: .36rem;}
  .bot-box .btn{width:2.4rem;height:.72rem;margin-top: .14rem;margin-left:.55rem;font:.32rem/.72rem "Microsoft YaHei";}
  .bot-box .bot-detail{font: .24rem/.98rem "Microsoft YaHei";color: #666;}
  .bot-box .bot-detail img{width: auto;height: .1rem;margin-top: .44rem;margin-left: .05rem;-webkit-transition: all ease .2s;transition: all ease .2s;}
  .bot-box .bot-detail.curr img{-webkit-transform: rotate(180deg);transform: rotate(180deg);}
  /*button.btn{width: auto;height: .54rem;padding: 0 .1rem;line-height: .54rem;border-radius: .16rem;background: #feca50;color: #fff;font-size: .24rem;}*/
  .bot-detail-alert{position: fixed;bottom:.99rem;top:0;left:0;z-index:9;width: 100%;}
  .bot-detail-con{position: absolute;left: 0;bottom: 0;width: 100%;padding: .3rem;border-radius: .3rem .3rem 0 0;background: #fff;}
  .bot-detail-con .detail-item{font: .28rem/.7rem "Microsoft YaHei";color: #333;}

  .ej-box{padding-top: .18rem;margin-top: .18rem; border-top: 1px solid #e3e3e3; line-height: .54rem;}
  .ej-box .l{width: 2.2rem;}
  .ej-box .r span{ display: inline-block; padding-left: .6rem;font-size: .3rem;color: #333; line-height: .54rem; background: url(../../assets/check.png) no-repeat left center;background-size: .4rem .4rem; }
  .ej-box .r .icon-che1{ margin-right: .4rem; }
  .ej-box .r span.curr{ background: url(../../assets/check-curr.png) no-repeat left center;background-size: .4rem .4rem; }
</style>



// WEBPACK FOOTER //
// src/page/home/order-create.vue